<template>
  <div>
    <van-popup
      v-model="isShow"
      position="right"
      lock-scroll
      close-on-popstate
      :style="{ height: '100%', width:'100%' }"
    >
      <ld-header
        @click-left="isShow = false"
        @click-right="complie"
      >
        <span
          slot="right"
          class="main-color"
        >
          {{ $t('B010','保存') }}
        </span>
      
        编辑个人信息
      </ld-header>
    
      <van-cell-group>
        <van-field
          :label="$t('D005','护照')"
          placeholder="请输入护照号码"
          v-model="passport"
          input-align="left"
          clearable
        />
      
        <van-field
          label="护照有效期"
          placeholder="请选择护照有效期"
          v-model="passportPeriod"
          @click="showDate = !showDate"
          input-align="left"
          readonly="true"
        />
        <van-popup
          lock-scroll="true"
          v-model="showDate"
          position="bottom"
          :close-on-popstate="true"
        >
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            :min-date="MIN_DATE"
            :max-date="MAX_DATE"
            @cancel="showDate = false"
            @confirm="dateSelect"
          />
        </van-popup>
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
import mixin from './mixin'
import { formatDate } from 'Utils/dateUtil'

export default {
  name: 'EditPassport',
  mixins: [mixin],
  data() {
    return {
      MIN_DATE: new Date(),
      MAX_DATE: new Date('2099-12-30'),
      showDate: false,
      currentDate: '',
      passport: '',
      passportPeriod: ''
    }
  },
  created () {
    this.passport = this.empInfo.passport
    this.passportPeriod = this.empInfo.passportPeriod
    this.currentDate = new Date(this.empInfo.passportPeriod)
  },
  methods: {
    dateSelect (date) {
      this.showDate = false
      this.passportPeriod = formatDate(date).date
    },
    complie () {
      if (!this.passport) {
        this.$toast('请填写护照号')
        return
      } else if (!this.passportPeriod) {
        this.$toast('请选择护照有效期')
        return
      }
      
      this.empInfo.passport = this.passport
      this.empInfo.passportPeriod = this.passportPeriod

      this.save()
    }
  }
}
</script>